import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import { ref, computed, watch } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import { getFirmwareList, upsertFirmware } from '@/api/evses'
import { ElMessage, ElMessageBox } from 'element-plus'
import EvseFirmwares from './EvseFirmwares.vue'
import { checkMenuShow } from '@/store/tool'
import FormRulesFactory from '@/common/formRules'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseModelFirmwares',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  evseModelInfo: {
    type: Object,
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { emit }) {

const props = __props

const firmwareFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['version'], 'inputEmpty', 'inputInvalid', {
    pattern: /^v\d+(\.\d+){0,3}$/,
  }),
  ...FormRulesFactory.generateCustomRules(['versionCode'], 'inputEmpty', 'inputInvalid', {
    pattern: /^[1-9]\d*$/,
  }),
})


const { tl, t } = useI18nTl('Evses')



const modelid = computed(() => {
  return props.evseModelInfo?.id
})

let subsForm = ref()
const record = ref<Record<string, any>>({})
const showDialog = computed({
  get: () => {
    subsForm.value?.clearValidate()
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const submit = async () => {
  await subsForm.value?.validate()
  record.value.modelID = modelid
  if (record.value.modelID == '') {
    record.value.modelID = '0'
  }

  upsertFirmware(record.value)
    .then((res: any) => {
      ElMessage.success(t(`Base.editSuccess`))
      showDialog.value = false
      record.value = {}
      emit('submitted')
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
      ElMessage.error(t(`Base.opErr`))
    })
}

watch(
  () => props.modelValue,
  (val) => {},
  { immediate: true },
)

const handleSelect = (item: any) => {
  record.value.firmwareID = item.id
  record.value.version = item.version
  record.value.versionCode = item.versionCode
  record.value.upgradeUrl = item.upgradeUrl
  record.value.desc = item.remark
}
const handleClear = () => {
  record.value.firmwareID = '0'
}

const querySearchAsync = (queryString: string, cb: any) => {
  if (queryString.length > 3) {
    // 输入内容以后才去做模糊查询
    setTimeout(() => {
      getFirmwareList({
        pageReq: {
          page: 1,
          limit: 10,
          search: queryString,
        },
        modelID: modelid.value,
      }).then((res: any) => {
        if (res.list?.length === 0) {
          cb([{ value: 'no data' }])
          return
        }

        let callBackArr = [] // 准备一个空数组，此数组是最终返给输入框的数组
        res.list.forEach((item) => {
          callBackArr.push({
            value: item.version,
            id: item.ID,
            version: item.version,
            versionCode: item.versionCode,
            upgradeUrl: item.upgradeUrl,
            remark: item.remark,
          })
        })
        cb(callBackArr)
      })
    }, 1000)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_role = _resolveDirective("role")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _unref(tl)('firmwareinfo'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer"
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: firmwareFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('version'),
                    prop: "version",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_autocomplete, {
                        style: {"width":"100%"},
                        modelValue: record.value.version,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.version) = $event)),
                        placeholder: "v1.3.0",
                        "fetch-suggestions": querySearchAsync,
                        onSelect: handleSelect,
                        clearable: "",
                        onClear: handleClear
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('versionCode'),
                    prop: "versionCode",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.versionCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.versionCode) = $event)),
                        placeholder: "1003000"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('firmwareAddress'),
                    prop: "upgradeUrl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.upgradeUrl,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.upgradeUrl) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.desc'),
                    prop: "desc"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 3,
                        modelValue: record.value.desc,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.desc) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_role, 'evseModelFirmwareUpsert']
      ]),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showDialog.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                disabled: !_ctx.$hasPermission('post'),
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.add')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(EvseFirmwares, { modelID: _unref(modelid) }, null, 8, ["modelID"]), [
            [_directive_role, 'evseModelFirmwares']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})